import { render, staticRenderFns } from "./pvpInquire.vue?vue&type=template&id=1e7c600c&scoped=true"
import script from "./pvpInquire.vue?vue&type=script&lang=js"
export * from "./pvpInquire.vue?vue&type=script&lang=js"
import style0 from "./pvpInquire.vue?vue&type=style&index=0&id=1e7c600c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7c600c",
  null
  
)

export default component.exports